export const ENGLISH = 0;
export const GUJARATI = 1;
export const HINDI = 2;
export const SPANISH = 3;
export const FRENCH = 4;
export const GERMAN = 5;
export const RUSSIAN = 6;
export const MANDARIN = 7;
export const PORTUGUESE = 8;
export const KOREAN = 9;
export const KANNADA = 10;

export const LanguageList = Object.freeze({
    ENGLISH: 0,
    GUJARATI: 1,
    HINDI: 2,
    SPANISH: 3,
    FRENCH: 4,
    GERMAN: 5,
    RUSSIAN: 6,
    MANDARIN: 7,
    PORTUGUESE: 8,
    KOREAN: 9,
    KANNADA: 10,
});
